import React from 'react';
import { connect } from 'react-redux';

import { CommonPage } from 'apps/auth/components/common/Layout/CommonPage/CommonPage';
import ActivityList from 'apps/auth/components/ga/activity/ActivityList';
import BasePage from 'apps/auth/components/utils/BasePage';
import { AUTH_GA_CARD } from 'apps/auth/constants/UrlConstants';
import { resolveArguments, toUpperCase } from 'apps/auth/helpers/utils';

const CardActivityListPage = (props) => {
    return (
        <CommonPage backUrl={`${AUTH_GA_CARD}${props.cardId}`}>
            <ActivityList
                fetchUrl={`/auth/ga/card/${props.cardId}/activity.next`}
                historyTitle={resolveArguments(props.cardActivityTitle, toUpperCase(props.last4Digits))}
                showStatement={props.showCardStatement}
                cardStatement={true}
            />
        </CommonPage>
    );
};

const mapStateToProps = (state) => {
    return {
        cardId: state.extra.card?.id,
        last4Digits: state.extra.card?.panGroupLast4Digits,
        showCardStatement: state.extra.showCardStatement,
        cardActivityTitle: state.messages.pageMessages.cardActivityTitle,
    };
};

export default connect(mapStateToProps, null)(BasePage(CardActivityListPage));
